import type { FaireProductEntity } from "../../entity_types/product";

export const p_rrpf769599: FaireProductEntity = {
  token: "p_rrpf769599",
  type: "product",
  name: "Bird Skull Ring - Gold Tone",
  brandToken: "b_592svxunwb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a3b077a86217626c0e8f86909d5347926280eaec736e1e326aa1efca88f8bd20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4294e90429995f70afa5708e3b8079204013f369434d1fce0c6207686c1ec3a9.png",
    "https://cdn.faire.com/fastly/b3f3c7236e43e6287c93e5e99981e24b3ee3831459da75c7b99a04167a4b8392.jpeg",
    "https://cdn.faire.com/fastly/109ed64b600d25637f145db4a49df538a9a5caa0f358442a715d8c3e5853cd75.jpeg",
  ],
  priceDollars: 39.12,
  description:
    "These sterling silver rings feature a gold toned raven skull that is cast in bronze from actual raven skull. The textured sterling silver bands range in sizes 8-10. ",
  tags: [],
  msrpDollars: 78.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:25.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
